module.exports = __webpack_public_path__ + "static/brick-hustle-21c665b1ce447155fc99b2c9e38491e1.jpg";